import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/Icon';
import Image from 'components/Image';
import Picture from 'components/Picture';

const CustomerManager = () => (
  <Fragment>
    <section className="section section_customer-manager_1">
      <div className="wrapper">
        <div className="row">
          <div className="col col-5 col-tablet-12">
            <h1 className="title title_size_xl title_white _mb-20 _mt-71 _mt-laptop-73 _mt-tablet-0 _mt-quad-99">
              Customer Manager
            </h1>
            <p className="text text_white text_size_xl section__text">
              Manage and support your customers from one central dashboard.
            </p>
          </div>
          <div className="col col-6 offset-1 col-tablet-12 offset-tablet-0">
            <div className="section__image-wrap _mb-tablet-60 _mt-quad-41">
              <Picture className="section__image" src="dashboard.svg" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_customer-manager_2">
      <div className="wrapper">
        <div className="row">
          <div className="col col-5 col-tablet-12">
            <div className="_mt-108 _mt-tablet-0 _mb-tablet-60">
              <h2 className="title title_size_l _mb-16">
                <span className="title__break">Your brand,</span> your way
              </h2>
              <p className="text">
                Host your customers' websites on your own servers or use our
                cloud hosting. With complete white labeling, you can style the
                Website Builder with your colors and logo then offer it as a
                standalone product or part of a bundle under your brand.
              </p>
            </div>
          </div>
          <div className="col col-7 col-tablet-12">
            <div className="section__images-group-wrap">
              <Image
                className="section__image-group_third"
                src="img-31-3.png"
              />
              <Image
                className="section__image-group_second"
                src="img-31-2.png"
              />
              <Image
                className="section__image-group_first"
                src="img-31-1.png"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_customer-manager_3">
      <div className="wrapper">
        <div className="row row-reverse-tablet section__row">
          <div className="col col-6 col-tablet-12">
            <div className="section__images-group-wrap">
              <Image
                className="section__image-group_third"
                src="img-33-3.png"
              />
              <Image
                className="section__image-group_second"
                src="img-33-2.png"
              />
              <Image
                className="section__image-group_first"
                src="img-33-1.png"
              />
            </div>
          </div>
          <div className="col col-4 offset-2 col-tablet-12 offset-tablet-0">
            <div className="_mt-109 _mt-laptop-0 _mb-tablet-60">
              <h2 className="title title_size_l title_white _mb-16">
                Easy customer management
              </h2>
              <p className="text text_white _mb-21">
                Maintain full control over billing, support and relationship
                management all within your Customer Manager control panel.
              </p>
              <p className="text text_white">
                Control what your customers do and the levels of access with
                User Permissions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_customer-manager_4">
      <div className="wrapper">
        <div className="row">
          <div className="col col-3 col-tablet-6 col-tablet-portrait-12">
            <div className="_mb-tablet-40">
              <div className="section__icon-wrap _mb-27">
                <Icon icon="icon-21" />
              </div>
              <h4 className="title section__title title_size_s_old _mb-22 _mb-laptop-16">
                <span className="title__break">Create your</span> Own Plans
              </h4>
              <p className="text section__text">
                Sell it any way you want with feature selection and page
                limitations.
              </p>
            </div>
          </div>
          <div className="col col-3 col-tablet-6 col-tablet-portrait-12">
            <div className="_mb-tablet-40">
              <div className="section__icon-wrap _mb-27">
                <Icon icon="icon-22" />
              </div>
              <h4 className="title section__title title_size_s_old _mb-22 _mb-laptop-16">
                Upgrade & Downgrade
              </h4>
              <p className="text section__text">
                Enjoy the flexibility to upgrade and downgrade your customer
                plans and terms.
              </p>
            </div>
          </div>
          <div className="col col-3 col-tablet-6 col-tablet-portrait-12">
            <div className="_mb-tablet-40">
              <div className="section__icon-wrap _mb-27">
                <Icon icon="icon-23" />
              </div>
              <h4 className="title section__title title_size_s_old _mb-22 _mb-laptop-16">
                Team Management
              </h4>
              <p className="text section__text">
                Set your team permissions with full or limited access to the
                Customer Manager control panel.
              </p>
            </div>
          </div>
          <div className="col col-3 col-tablet-6 col-tablet-portrait-12">
            <div className="_mb-tablet-40">
              <div className="section__icon-wrap _mb-27">
                <Icon icon="icon-24" />
              </div>
              <h4 className="title section__title title_size_s_old _mb-22 _mb-laptop-16">
                Customer Support
              </h4>
              <p className="text section__text">
                Inbuilt step&#8209;by&#8209;step tutorials, quick tips and FAQ's
                to help guide your customers through common tasks.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_customer-manager_5">
      <div className="wrapper">
        <div className="row">
          <div className="col col-6 section__col">
            <div className="section__image-wrap">
              <Image className="section__image" src="img-34.png" />
            </div>
          </div>
          <div className="col col-5 col-tablet-12 offset-1 offset-tablet-0">
            <h2 className="title title_size_l title_white _mb-16 _mt-164 _mt-tablet-0">
              Retain customers
            </h2>
            <p className="text text_white">
              Many site builder products have failed to deliver a simple and
              fast website builder solution, which has affected the renewal
              subscription. Siteplus fulfills these needs with a reduction in
              churn and an increase in your ARPU and retention.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_customer-manager_6">
      <div className="wrapper">
        <h2 className="title section__main-title _mb-67">
          Own the customer experience
        </h2>
        <div className="row">
          <div className="col col-4 col-tablet-portrait-12">
            <div className="_mb-68">
              <div className="section__icon-wrap _mb-31 _mb-laptop-27">
                <Icon icon="icon-25" />
              </div>
              <h4 className="title section__title title_size_s_old _mb-22 _mb-laptop-16">
                Free Trials
              </h4>
              <p className="text section__text">
                Offer customers a free trial so they can experience the
                simplicity of the Website Builder at no cost to you.
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="_mb-68">
              <div className="section__icon-wrap _mb-31 _mb-laptop-27">
                <Icon icon="icon-26" />
              </div>
              <h4 className="title section__title title_size_s_old _mb-22 _mb-laptop-16">
                Internal Upgrades
              </h4>
              <p className="text section__text">
                Offer additional value&#8209;added products and services with
                internal upgrades your customers can experience within the
                Website Builder.
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="_mb-68">
              <div className="section__icon-wrap _mb-31 _mb-laptop-27">
                <Icon icon="icon-27" />
              </div>
              <h4 className="title section__title title_size_s_old _mb-22 _mb-laptop-16">
                Any Domain
              </h4>
              <p className="text section__text">
                Customers can connect any domain from any provider or they can
                register a new domain using your domain name services.
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="_mb-68">
              <div className="section__icon-wrap _mb-31 _mb-laptop-27">
                <Icon icon="icon-28" />
              </div>
              <h4 className="title section__title title_size_s_old _mb-22 _mb-laptop-16">
                Landing Pages
              </h4>
              <p className="text section__text">
                Add value with landing pages, bundle with domain names, hosting
                or any other product at no cost to you.
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="_mb-68">
              <div className="section__icon-wrap _mb-31 _mb-laptop-27">
                <Icon icon="icon-29" />
              </div>
              <h4 className="title section__title title_size_s_old _mb-22 _mb-laptop-16">
                DIFY Option
              </h4>
              <p className="text section__text">
                Offer your customers the DIFY (Do It For You) design option.
                With our Staging site editor, anyone can quickly build a
                website.
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="_mb-68">
              <div className="section__icon-wrap _mb-31 _mb-laptop-27">
                <Icon icon="icon-30" />
              </div>
              <h4 className="title section__title title_size_s_old _mb-22 _mb-laptop-16">
                Easy Onboarding
              </h4>
              <p className="text section__text">
                Every new customer will be prompted with a simple guided walk
                through to quickly get them started.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_customer-manager_7">
      <div className="wrapper">
        <div className="row">
          <div className="col col-6 col-tablet-12">
            <div className="_mt-99 _mt-tablet-0 _mb-tablet-60">
              <h2 className="title title_size_l _mb-16">
                Integrate & Manage your customers
              </h2>
              <p className="text _mb-16">
                Offer your customers a powerful and simple Website Builder they
                can access directly through your web hosting platform or
                website.
              </p>
              <p className="text _mb-16">
                The Website Builder is fully white label and integrates
                perfectly with cPanel, Plesk and WHMCS &ndash; the choice is
                yours.
              </p>
              <p className="text _mb-24">
                We also offer a developer API for custom integration.
              </p>
              <Link to="/simple-integration" className="link">
                View integration options
                <Icon className="link__icon" icon="arrow-text-2" />
              </Link>
            </div>
          </div>
          <div className="col col-6 col-tablet-12 section__col">
            <div className="section__image-wrap">
              <Image className="section__image" src="simple-integration.svg" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </Fragment>
);

export default CustomerManager;
